import { render } from "./master-notifications.vue?vue&type=template&id=4ff49bcb"
import script from "./master-notifications.vue?vue&type=script&lang=js"
export * from "./master-notifications.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__